var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 25,
    viewBox: "0 4 32 25",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.2
    },
    cx: 9.902,
    cy: 22.244,
    rx: 15.315,
    ry: 6.281,
    transform: "matrix(0.97235312,-0.23351535,0.28643384,0.95810002,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4f4f4f"
    },
    d: "m 14.999999,6.9999972 c -6.9999997,0 -5.3718577,6.1708868 -8.9558637,8.0970968 -3.636053,2.06286 -1.632773,3.909577 -1.044136,5.902903 0.993082,3.323732 3.774955,0.975422 11.9999997,-1 8.224645,-1.974968 9.993206,-1.676515 9,-5 -0.595535,-1.971097 1.359116,-3.797884 -2.891142,-3.971833 -3.454568,0.189212 -3.108858,-4.0281668 -8.108858,-4.0281668 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#ffffff"
    },
    d: "M 15 7 C 8.0000003 7 9.6289279 13.171446 6.0449219 15.097656 C 4.1059245 16.197717 3.7857145 17.235438 3.984375 18.267578 C 4.1577529 17.560805 4.7297109 16.841868 6.0449219 16.095703 C 9.6289279 14.169493 8.0000003 8 15 8 C 20 8 19.654807 12.216556 23.109375 12.027344 C 25.193109 12.112624 25.783376 12.596771 25.916016 13.298828 C 26.017914 12.081746 26.072979 11.148634 23.109375 11.027344 C 19.654807 11.216556 20 7 15 7 z M 25.904297 14.429688 C 25.863911 14.922043 25.834805 15.453239 26 16 C 26.089401 16.299155 26.1475 16.559924 26.189453 16.804688 C 26.305345 16.348711 26.23174 15.775454 26 15 C 25.941709 14.807068 25.921934 14.618439 25.904297 14.429688 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#2e72de"
    },
    cx: 10.189,
    cy: 21.271,
    rx: 15.315,
    ry: 6.281,
    transform: "matrix(0.97235312,-0.23351535,0.28643384,0.95810002,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.2
    },
    cx: 11.55,
    cy: 26.811,
    rx: 7.163,
    ry: 3.153,
    transform: "matrix(0.97262806,-0.23236752,0.21506239,0.97660031,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#ffffff"
    },
    cx: 11.765,
    cy: 25.838,
    rx: 7.163,
    ry: 3.153,
    transform: "matrix(0.97262806,-0.23236752,0.21506239,0.97660031,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#ffffff"
    },
    d: "M 21.560547 11.003906 A 6.2692939 15.31979 77.128662 0 0 14.201172 11.982422 A 6.2692939 15.31979 77.128662 0 0 1.0566406 21.273438 A 6.2692939 15.31979 77.128662 0 1 14.201172 12.982422 A 6.2692939 15.31979 77.128662 0 1 30.892578 15.423828 A 6.2692939 15.31979 77.128662 0 1 30.943359 15.726562 A 6.2692939 15.31979 77.128662 0 0 30.892578 14.423828 A 6.2692939 15.31979 77.128662 0 0 21.560547 11.003906 z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYd);
export default __webpack_public_path__ + "static/media/YD.04a51b7b309d796a014733ca0aa7731f.svg";
export { ForwardRef as ReactComponent };